(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@angular/core'), require('@angular/common'), require('@shraddhar/web/icon'), require('@shraddhar/web/tab-indicator'), require('@angular/cdk/coercion'), require('rxjs'), require('rxjs/operators'), require('@shraddhar/web/base'), require('@shraddhar/web/ripple'), require('@material/tab'), require('@material/ripple')) :
    typeof define === 'function' && define.amd ? define('@shraddhar/web/tab', ['exports', '@angular/core', '@angular/common', '@shraddhar/web/icon', '@shraddhar/web/tab-indicator', '@angular/cdk/coercion', 'rxjs', 'rxjs/operators', '@shraddhar/web/base', '@shraddhar/web/ripple', '@material/tab', '@material/ripple'], factory) :
    (global = global || self, factory((global.shraddhar = global.shraddhar || {}, global.shraddhar.web = global.shraddhar.web || {}, global.shraddhar.web.tab = {}), global.ng.core, global.ng.common, global.ng.web.icon, global.ng.web.tabIndicator, global.ng.cdk.coercion, global.rxjs, global.rxjs.operators, global.ng.web.base, global.ng.web.ripple, global.mdc.tab, global.mdc.ripple));
}(this, (function (exports, core, common, icon, tabIndicator, coercion, rxjs, operators, base, ripple, tab, ripple$1) { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __rest(s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                    t[p[i]] = s[p[i]];
            }
        return t;
    }

    function __decorate(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    }

    function __param(paramIndex, decorator) {
        return function (target, key) { decorator(target, key, paramIndex); }
    }

    function __metadata(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
    }

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    function __exportStar(m, exports) {
        for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
    }

    function __values(o) {
        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === "number") return {
            next: function () {
                if (o && i >= o.length) o = void 0;
                return { value: o && o[i++], done: !o };
            }
        };
        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
    }

    function __read(o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o), r, ar = [], e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        }
        catch (error) { e = { error: error }; }
        finally {
            try {
                if (r && !r.done && (m = i["return"])) m.call(i);
            }
            finally { if (e) throw e.error; }
        }
        return ar;
    }

    function __spread() {
        for (var ar = [], i = 0; i < arguments.length; i++)
            ar = ar.concat(__read(arguments[i]));
        return ar;
    }

    function __spreadArrays() {
        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
        for (var r = Array(s), k = 0, i = 0; i < il; i++)
            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
                r[k] = a[j];
        return r;
    };

    function __await(v) {
        return this instanceof __await ? (this.v = v, this) : new __await(v);
    }

    function __asyncGenerator(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var g = generator.apply(thisArg, _arguments || []), i, q = [];
        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
        function fulfill(value) { resume("next", value); }
        function reject(value) { resume("throw", value); }
        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
    }

    function __asyncDelegator(o) {
        var i, p;
        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
    }

    function __asyncValues(o) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var m = o[Symbol.asyncIterator], i;
        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
    }

    function __makeTemplateObject(cooked, raw) {
        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
        return cooked;
    };

    function __importStar(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
        result.default = mod;
        return result;
    }

    function __importDefault(mod) {
        return (mod && mod.__esModule) ? mod : { default: mod };
    }

    function __classPrivateFieldGet(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
    }

    function __classPrivateFieldSet(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
    }

    /**
     * Injection token used to provide the parent MdcTabBar component to MdcTab.
     */
    var MDC_TAB_BAR_PARENT_COMPONENT = new core.InjectionToken('MDC_TAB_BAR_PARENT_COMPONENT');
    var nextUniqueId = 0;
    var MdcTabLabel = /** @class */ (function () {
        function MdcTabLabel(elementRef) {
            this.elementRef = elementRef;
        }
        MdcTabLabel.decorators = [
            { type: core.Directive, args: [{
                        selector: 'mdc-tab-label, [mdcTabLabel]',
                        host: { 'class': 'mdc-tab__text-label' }
                    },] }
        ];
        /** @nocollapse */
        MdcTabLabel.ctorParameters = function () { return [
            { type: core.ElementRef }
        ]; };
        return MdcTabLabel;
    }());
    var MdcTabIcon = /** @class */ (function () {
        function MdcTabIcon(elementRef) {
            this.elementRef = elementRef;
        }
        MdcTabIcon.decorators = [
            { type: core.Directive, args: [{
                        selector: 'mdc-tab-icon, [mdcTabIcon]',
                        host: { 'class': 'mdc-tab__icon' }
                    },] }
        ];
        /** @nocollapse */
        MdcTabIcon.ctorParameters = function () { return [
            { type: core.ElementRef }
        ]; };
        return MdcTabIcon;
    }());
    var MdcTab = /** @class */ (function (_super) {
        __extends(MdcTab, _super);
        function MdcTab(_ngZone, _changeDetectorRef, _ripple, elementRef, _parent) {
            var _this = _super.call(this, elementRef) || this;
            _this._ngZone = _ngZone;
            _this._changeDetectorRef = _changeDetectorRef;
            _this._ripple = _ripple;
            _this.elementRef = elementRef;
            _this._parent = _parent;
            /** Emits whenever the component is destroyed. */
            _this._destroy = new rxjs.Subject();
            _this._uniqueId = "mdc-tab-" + ++nextUniqueId;
            _this.id = _this._uniqueId;
            _this._stacked = false;
            _this._fixed = false;
            _this._disabled = false;
            _this._focusOnActivate = true;
            _this.interacted = new core.EventEmitter();
            _this._root = _this.elementRef.nativeElement;
            return _this;
        }
        Object.defineProperty(MdcTab.prototype, "stacked", {
            get: function () {
                return this._stacked;
            },
            set: function (value) {
                var newValue = coercion.coerceBooleanProperty(value);
                if (newValue !== this._stacked) {
                    this._stacked = newValue;
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTab.prototype, "fixed", {
            get: function () {
                return this._fixed;
            },
            set: function (value) {
                var newValue = coercion.coerceBooleanProperty(value);
                if (newValue !== this._fixed) {
                    this._fixed = newValue;
                    this._changeDetectorRef.detectChanges();
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTab.prototype, "disabled", {
            get: function () {
                return this._disabled;
            },
            set: function (value) {
                this._disabled = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTab.prototype, "focusOnActivate", {
            get: function () {
                return this._focusOnActivate;
            },
            set: function (value) {
                var newValue = coercion.coerceBooleanProperty(value);
                if (newValue !== this._focusOnActivate) {
                    this._focusOnActivate = newValue;
                    this._foundation.setFocusOnActivate(this._focusOnActivate);
                }
            },
            enumerable: true,
            configurable: true
        });
        MdcTab.prototype.getDefaultFoundation = function () {
            var _this = this;
            var adapter = {
                setAttr: function (attr, value) { return _this._getHostElement().setAttribute(attr, value); },
                addClass: function (className) { return _this._getHostElement().classList.add(className); },
                removeClass: function (className) { return _this._getHostElement().classList.remove(className); },
                hasClass: function (className) { return _this._getHostElement().classList.contains(className); },
                activateIndicator: function (previousIndicatorClientRect) {
                    return _this.tabIndicator.activate(previousIndicatorClientRect);
                },
                deactivateIndicator: function () { return _this.tabIndicator.deactivate(); },
                notifyInteracted: function () { return _this.interacted.emit({ detail: { tabId: _this.id, tab: _this } }); },
                getOffsetLeft: function () { return _this._getHostElement().offsetLeft; },
                getOffsetWidth: function () { return _this._getHostElement().offsetWidth; },
                getContentOffsetLeft: function () { return _this.content.nativeElement.offsetLeft; },
                getContentOffsetWidth: function () { return _this.content.nativeElement.offsetWidth; },
                focus: function () { return _this._getHostElement().focus(); }
            };
            return new tab.MDCTabFoundation(adapter);
        };
        MdcTab.prototype.ngOnInit = function () {
            this._foundation.init();
            this._loadListeners();
        };
        MdcTab.prototype.ngAfterViewInit = function () {
            this._ripple = this._createRipple();
            this._ripple.init();
        };
        MdcTab.prototype.ngOnDestroy = function () {
            this._destroy.next();
            this._destroy.complete();
            this._ripple.destroy();
        };
        Object.defineProperty(MdcTab.prototype, "active", {
            /** Getter for the active state of the tab */
            get: function () {
                return this._foundation.isActive();
            },
            enumerable: true,
            configurable: true
        });
        /** Activates the tab */
        MdcTab.prototype.activate = function (computeIndicatorClientRect) {
            this._foundation.activate(computeIndicatorClientRect);
        };
        /** Deactivates the tab */
        MdcTab.prototype.deactivate = function () {
            this._foundation.deactivate();
        };
        /** Returns the indicator's client rect */
        MdcTab.prototype.computeIndicatorClientRect = function () {
            return this.tabIndicator.computeContentClientRect();
        };
        MdcTab.prototype.computeDimensions = function () {
            return this._foundation.computeDimensions();
        };
        MdcTab.prototype.getTabBarParent = function () {
            return this._parent;
        };
        MdcTab.prototype.focus = function () {
            this._getHostElement().focus();
        };
        MdcTab.prototype._createRipple = function () {
            var rippleSurface = this.rippleSurface.nativeElement;
            var adapter = __assign(__assign({}, ripple.MdcRipple.createAdapter(this)), { addClass: function (className) { return rippleSurface.classList.add(className); }, removeClass: function (className) { return rippleSurface.classList.remove(className); }, updateCssVariable: function (varName, value) { return rippleSurface.style.setProperty(varName, value); } });
            return new ripple.MdcRipple(this.elementRef, new ripple$1.MDCRippleFoundation(adapter));
        };
        MdcTab.prototype._loadListeners = function () {
            var _this = this;
            this._ngZone.runOutsideAngular(function () {
                return rxjs.fromEvent(_this._getHostElement(), 'click').pipe(operators.takeUntil(_this._destroy))
                    .subscribe(function () { return _this._ngZone.run(function () {
                    if (!_this.active && !_this._disabled) {
                        _this._foundation.handleClick();
                    }
                }); });
            });
        };
        /** Retrieves the DOM element of the component host. */
        MdcTab.prototype._getHostElement = function () {
            return this.elementRef.nativeElement;
        };
        MdcTab.decorators = [
            { type: core.Component, args: [{
                        selector: '[mdcTab], mdc-tab',
                        exportAs: 'mdcTab',
                        host: {
                            '[id]': 'id',
                            'role': 'tab',
                            'class': 'mdc-tab',
                            '[class.mdc-tab--stacked]': 'stacked',
                            '[class.mdc-tab--min-width]': 'fixed',
                            '[class.ngx-mdc-tab--disabled]': 'disabled'
                        },
                        template: "<div #content class=\"mdc-tab__content\">\r\n  <mdc-icon class=\"mdc-tab__icon\" *ngIf=\"icon\">{{icon}}</mdc-icon>\r\n  <ng-content select=\"mdc-icon\"></ng-content>\r\n  <span class=\"mdc-tab__text-label\" *ngIf=\"label\">{{label}}</span>\r\n  <ng-content></ng-content>\r\n  <ng-container *ngIf=\"fixed\">\r\n    <ng-container *ngTemplateOutlet=\"indicator\"></ng-container>\r\n  </ng-container>\r\n</div>\r\n<ng-container *ngIf=\"!fixed\">\r\n  <ng-container *ngTemplateOutlet=\"indicator\"></ng-container>\r\n</ng-container>\r\n<ng-template #indicator>\r\n  <mdc-tab-indicator></mdc-tab-indicator>\r\n</ng-template>\r\n<div #ripplesurface class=\"mdc-tab__ripple\"></div>",
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        encapsulation: core.ViewEncapsulation.None,
                        providers: [ripple.MdcRipple]
                    }] }
        ];
        /** @nocollapse */
        MdcTab.ctorParameters = function () { return [
            { type: core.NgZone },
            { type: core.ChangeDetectorRef },
            { type: ripple.MdcRipple },
            { type: core.ElementRef },
            { type: undefined, decorators: [{ type: core.Optional }, { type: core.Inject, args: [MDC_TAB_BAR_PARENT_COMPONENT,] }] }
        ]; };
        MdcTab.propDecorators = {
            id: [{ type: core.Input }],
            label: [{ type: core.Input }],
            icon: [{ type: core.Input }],
            stacked: [{ type: core.Input }],
            fixed: [{ type: core.Input }],
            disabled: [{ type: core.Input }],
            focusOnActivate: [{ type: core.Input }],
            interacted: [{ type: core.Output }],
            content: [{ type: core.ViewChild, args: ['content', { static: false },] }],
            rippleSurface: [{ type: core.ViewChild, args: ['ripplesurface', { static: false },] }],
            tabIndicator: [{ type: core.ViewChild, args: [tabIndicator.MdcTabIndicator, { static: false },] }]
        };
        return MdcTab;
    }(base.MDCComponent));

    var TAB_DECLARATIONS = [
        MdcTab,
        MdcTabIcon,
        MdcTabLabel
    ];
    var MdcTabModule = /** @class */ (function () {
        function MdcTabModule() {
        }
        MdcTabModule.decorators = [
            { type: core.NgModule, args: [{
                        imports: [
                            common.CommonModule,
                            tabIndicator.MdcTabIndicatorModule,
                            icon.MdcIconModule
                        ],
                        exports: TAB_DECLARATIONS,
                        declarations: TAB_DECLARATIONS
                    },] }
        ];
        return MdcTabModule;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    exports.MDC_TAB_BAR_PARENT_COMPONENT = MDC_TAB_BAR_PARENT_COMPONENT;
    exports.MdcTab = MdcTab;
    exports.MdcTabIcon = MdcTabIcon;
    exports.MdcTabLabel = MdcTabLabel;
    exports.MdcTabModule = MdcTabModule;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=web-tab.umd.js.map
